import React from 'react';
import PropTypes from 'prop-types';

import Link from '@zg-rentals/multibrand-ui/lib/Link';
import { BrandContext } from '@zg-rentals/multibrand-ui/lib/BrandContext';
import './style.scss';
import withContext from '../../../utils/withContext';

interface IImpersonationNavProps {
  emailAddress: string;
  handleStopImpersonatingClick: () => void;
  brandContext: BrandContext;
}

class ImpersonationNav extends React.Component<IImpersonationNavProps> {
  static propTypes = {
    emailAddress: PropTypes.string.isRequired,
    handleStopImpersonatingClick: PropTypes.func.isRequired,
  };

  render() {
    const {
      emailAddress,
      handleStopImpersonatingClick,
      brandContext: { brand },
    } = this.props;

    const inspectUserUrl =
      '/rental-manager-api/inspectorTool/userInspectorTool' +
      `?zgBrand=${brand}&userIdentifier=${emailAddress}&submitAction=inspectUser`;

    return (
      <div className="ImpersonationNav">
        <span className="ImpersionationNav-bold-red">Impersonating</span>
        <Link href={inspectUserUrl} target="_blank">
          {emailAddress}&nbsp;
        </Link>
        <Link onClick={handleStopImpersonatingClick}>Stop Impersonating</Link>
      </div>
    );
  }
}

export default withContext(ImpersonationNav, BrandContext, 'brandContext');
